import styled from "styled-components";

import View from "../../../../views/View";

export const ViewStyled = styled(View)`
    padding-bottom: 0;
`;